import { render, staticRenderFns } from "./BackgroundGroup.vue?vue&type=template&id=b6763ae6&"
import script from "./BackgroundGroup.vue?vue&type=script&lang=js&"
export * from "./BackgroundGroup.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports